import { ResourceTileClient } from "../clients/ResourceTileClient";

export interface ContentfulTileProps {
    id: string;
    title: string;
    description: any;
    thumbnail: string;
    displayName: string;
    images: string[];
    url: string;
    tags: string[];
    data: Record<string, any>;
  }

export const cleanUpTiles = (rawData: any[]): ContentfulTileProps[] => {
  const parsedData = JSON.parse(JSON.stringify(rawData));
    return parsedData.map((tile) => {
      const { sys, fields } = tile;
      const tileData: ContentfulTileProps = {
        id: sys?.id || "",
        title: fields?.title || "No title",
        description: fields?.description || "No description",
        thumbnail: fields?.thumbnail?.fields?.file?.url || "",
        displayName: fields?.displayName || "",
        images: fields?.images || [],
        url: fields?.url || "#",
        tags: fields?.tags || [],
        data: fields?.data || {},
      }
      return tileData;
    });
  };

  export interface TaggedResourceTiles {
    data: ContentfulTileProps[];
    tagFilter: string;
  }

export const fetchResourceTilesByTagFilters = async (tagFilters: string[]): Promise<TaggedResourceTiles[]> => {
  const requests = tagFilters.map(async (tagFilter) => {
    const data = await ResourceTileClient.getEntries({
      content_type: "resourceTile",
      "fields.tags[in]": tagFilter,
    });
    if(data.items && Array.isArray(data.items)) {
      return {
        data: data.items,
        tagFilter: tagFilter,
      }
    }
    return {
      data: [],
      tagFilter: tagFilter,
    }
  });
  const results = await Promise.all(requests);
  return results.map((result) => {
    return {
      data: cleanUpTiles(result.data),
      tagFilter: result.tagFilter,
    }
  });
}